import React from "react";
import SecondaryMemberInvite from "../../components/Merchant/MerchantOnboarding/MemberInvite";

const MemberInvite = () => {
  return <SecondaryMemberInvite />;
};

export default MemberInvite;
